



import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  PencilIcon,
  TrashIcon,
  PlusIcon,
  CheckIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import {
  fetchProducts,
  deleteProducts,
  // getProductsByCompanyId,
} from "../../features/admin/ProductSlice";

import { getCompanyByUserId } from "../../features/admin/CompanySlice";
import TableComponent from "../../components/TableComponent";
import ProductModal from "../../components/admin/ProductModal";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import ConfirmModal from "../../components/ConfirmModal";
import { toast } from "react-toastify";
import { formatCurrencyVND } from "../../utils/helps";
import ApiCustom from "../../utils/ApiCustom";
import StatusDropdown from "../../components/admin/StatusDropdownButton";
import AuditHistoryButton, {
  canViewAuditHistory,
} from "../../components/admin/AuditHistoryButton";

const Products = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const [isPendingOpen, setIsPendingOpen] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [companyInfo, setCompanyInfo] = useState({});
  const [products, setProducts] = useState([]);
  const [contentModal, setContentModal] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const handleOpenModal = (item = null) => {
    setCurrentProduct(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentProduct(null);
    getProducts(companyInfo?.id);
  };

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
    getCompanyInfo();
  };

  const handleOpenApproveModal = (item = null) => {
    setCurrentProduct(item);
    setContentModal("Bạn có muốn duyệt sản phẩm này không");
    setIsApproveOpen(true);
  };

  const handleCloseApproveModal = () => {
    setIsApproveOpen(false);
    setCurrentProduct(null);
    setContentModal("");
    getProducts(companyInfo?.id);
  };

  const handleOpenPendingModal = (item = null) => {
    setCurrentProduct(item);
    setContentModal("Bạn có muốn bỏ duyệt sản phẩm này không");
    setIsPendingOpen(true);
  };

  const handleClosePendingModal = () => {
    setIsPendingOpen(false);
    setCurrentProduct(null);
    setContentModal("");
    getProducts(companyInfo?.id);
  };

  const handleApproveProduct = () => {
    ApiCustom.put("/product-approve/" + currentProduct?.id, {
      approveStatus: "approved",
    })
      .then((res) => {
        toast.success("Duyệt sản phẩm thành công");
        handleCloseApproveModal();
      })
      .catch((err) => console.log(err));
  };

  const handlePendingProduct = () => {
    ApiCustom.put("/product-approve/" + currentProduct?.id, {
      approveStatus: "pending",
    })
      .then((res) => {
        toast.success("Duyệt sản phẩm thành công");
        handleClosePendingModal();
      })
      .catch((err) => console.log(err));
  };

  const handleDelete = async () => {
    try {
      await dispatch(deleteProducts(deleteId)).unwrap();
      toast.success("Xóa sản phẩm thành công!");
      handleCloseDeleteModal();
    } catch (error) {
      toast.error("Đã xảy ra lỗi khi xóa đối tác!");
    }
  };

  const userId = localStorage.getItem("userId");
  useEffect(() => {
    getCompanyInfo();
  }, []);

  const getCompanyInfo = async () => {
    const companyData = await dispatch(getCompanyByUserId(userId)).unwrap();
    setCompanyInfo(companyData);
    getProducts(companyData?.id);
  };

  const getProducts = async (id) => {
    // if (userId == 1 || hasPermission("PRODUCT_SHOW_LIST")) {
    //   const productsData = await dispatch(fetchProducts()).unwrap();
    //   setProducts(productsData);
    //   return;
    // }
    const productsData = await dispatch(fetchProducts()).unwrap();
    setProducts(productsData);
  };

  const getUserPermissions = () => {
    const permissions = localStorage.getItem("permissions");
    return permissions
      ? JSON.parse(permissions).map((p) => p.permissionSlug)
      : [];
  };

  const hasPermission = (requiredPermission) => {
    if (userId == 1) {
      return true;
    }
    const userPermissions = getUserPermissions();
    return userPermissions.includes(requiredPermission);
  };

  const headers = [
    {
      key: "urlImage",
      label: "Hình ảnh",
      render: (item) => (
        <div className="w-24 h-24 overflow-hidden">
          {item.urlImage ? (
            <img
              src={item.urlImage}
              alt={item.urlImage}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-gray-200 flex items-center justify-center text-gray-400">
              No img
            </div>
          )}
        </div>
      ),
    },
    {
      key: "name",
      label: "Tên sản phẩm",
      render: (item) => (
        <div>
          <p className="font-medium">{item.name}</p>
          {/* <p className="text-sm text-gray-500">{item.description}</p> */}
        </div>
      ),
    },
    {
      label: "Đơn vị",
      render: (item) => (
        <div>
          <p className="font-medium">{item.company?.companyName}</p>
        </div>
      ),
    },
    {
      key: "priority",
      label: "Ưu tiên",
      render: (item) => (
        <div>
          <p className="font-medium">{item.priority}</p>
        </div>
      ),
    },
    {
      key: "price",
      label: "Giá tiền",
      render: (item) => (
        <div>
          <p className="font-medium">{formatCurrencyVND(item.price)}</p>
        </div>
      ),
    },
    {
      key: "priceLess",
      label: "Giảm giá",
      render: (item) => (
        <div>
          <p className="font-medium">
            {item.discountPrice && Number(item.discountPrice) != 0
              ? Math.round(
                  ((item.price - item.discountPrice) / item.price) * 100
                )
              : 0}
            %
          </p>
        </div>
      ),
    },
    {
      key: "status",
      label: "Trạng thái",
      render: (item) => (
        <span
          className={`px-3 py-1 rounded-full text-sm ${
            item.status === "available"
              ? "bg-green-100 text-green-800"
              : item.status === "out_of_stock"
              ? "bg-yellow-100 text-yellow-800"
              : "bg-red-100 text-red-800"
          } whitespace-nowrap`}
        >
          {item.status === "available"
            ? "Hiện có"
            : item.status === "out_of_stock"
            ? "Hết hàng"
            : "Ngưng cung cấp"}
        </span>
      ),
    },
  ];

  if (hasPermission("PRODUCT_APPROVE")) {
    headers.push({
      key: "approveStatus",
      label: "Trạng thái duyệt",
      render: (item) => (
        <StatusDropdown
          options={[
            { value: "approved", label: "Đã duyệt" },
            { value: "pending", label: "Chưa duyệt" },
          ]}
          value={item.approveStatus}
          onChange={(newStatus) => {
            if (newStatus === "approved") {
              handleOpenApproveModal(item);
            } else {
              handleOpenPendingModal(item);
            }
          }}
          getStatusStyle={(value) =>
            value === "approved"
              ? "bg-green-100 text-green-800"
              : "bg-yellow-100 text-yellow-800"
          }
        />
      ),
    });
  }

  if (
    hasPermission("PRODUCT_UPDATE") ||
    hasPermission("PRODUCT_DELETE") ||
    canViewAuditHistory()
  ) {
    headers.push({ key: "setting", label: "Thao tác" });
  }

  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        {hasPermission("PRODUCT_UPDATE") && (
          <button
            onClick={() => handleOpenModal(item)}
            disabled={item?.approveStatus == "approved"}
            title="Chỉnh sửa"
            className="btn btn-outline btn-info btn-sm px-3 my-1 rounded"
          >
            <PencilIcon className="w-5 h-5" />
          </button>
        )}
        {hasPermission("PRODUCT_DELETE") && (
          <button
            onClick={() => handleOpenDeleteModal(item.id)}
            disabled={item?.approveStatus == "approved"}
            title="Xóa"
            className="btn btn-outline btn-error btn-sm px-3 my-1 rounded"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        )}
        <AuditHistoryButton
          module="PRODUCT"
          entityType="Product"
          entityId={item.id}
        />
      </div>
    ),
  };

  const filterData = products.filter((item) =>
    searchValue === ""
      ? true
      : [item.name, item.company?.companyName].some((field) =>
          field?.toLowerCase().includes(searchValue.toLowerCase())
        )
  );

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold ">Quản lý sản phẩm</h1>
      </div>
      <div className="flex justify-between items-center mb-3">
        {hasPermission("PRODUCT_CREATE") ? (
          <button
            onClick={() => handleOpenModal()}
            className="btn btn-success transition-colors px-4 py-2 rounded mb-4"
          >
            <PlusIcon className="w-5 h-5" />
            <span>Thêm sản phẩm</span>
          </button>
        ) : (
          <div></div>
        )}
        <div className=" flex items-center space-x-2">
          <label
            htmlFor="userSearchFilter"
            className="text-sm font-medium w-24"
          >
            Tìm kiếm:
          </label>
          <input
            type="search"
            className="w-full px-2 py-1 border rounded-lg focus:outline-none pr-10"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      </div>
      <div className="rounded-lg shadow">
        <TableComponent
          headers={headers}
          data={filterData}
          settings={tableSettings}
        />
      </div>

      {isModalOpen && (
        <ProductModal
          productSlug={currentProduct?.slug || null}
          company={companyInfo}
          onClose={handleCloseModal}
        />
      )}

      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDelete}
      />

      <ConfirmModal
        isOpen={isApproveOpen}
        onClose={handleCloseApproveModal}
        message={contentModal}
        onSubmit={handleApproveProduct}
      />

      <ConfirmModal
        isOpen={isPendingOpen}
        onClose={handleClosePendingModal}
        message={contentModal}
        onSubmit={handlePendingProduct}
      />
    </div>
  );
};

export default Products;
